module.exports = __webpack_public_path__ + "img/青岛安芮嘉.f34e9d6.png";